import { html, LitElement, css } from 'lit';
import { property, state } from 'lit/decorators.js';
import { TimeoutController } from '../controllers/timeout-controller.js';
import { TWStyles } from '../styles/tw.js';

export class IxAutoLogoutDialog extends LitElement {
  static styles = [
    TWStyles,
    css`
      :host {
        --md-dialog-container-color: #fff;
        --md-focus-ring-color: transparent;
        --md-dialog-container-shape: 6px;
      }
    `,
  ];

  @property({ type: Boolean }) open = false;

  @property({ type: Number }) timer = 300000;

  @property({ type: Number, attribute: 'opened-at' }) openedAt = +new Date();

  externalCheck?: Function;

  // eslint-disable-next-line class-methods-use-this
  timeoutAction = () => {
    window.location.href = '/logout?isIdle=true';
  };

  private _timerInterval = 1000;

  @state()
  private _tickingTimer = 0;

  private timeoutController = new TimeoutController(
    this,
    async () => +new Date() - this.openedAt >= this.timer,
    () => this.timeoutAction(),
    () => {
      this._tickingTimer += this._timerInterval;
      if (this.externalCheck) {
        this.externalCheck();
      }
    },
    this._timerInterval,
  );

  private _handleOpened() {
    this.timeoutController.setInterval();
  }

  private _handleClosed() {
    this._tickingTimer = 0;
    this.timeoutController.clearInterval();
    this.dispatchEvent(new Event('closed'));
  }

  render() {
    const now = +new Date();
    const openedAt = this.openedAt > 0 ? this.openedAt : now;
    const timeInSeconds =
      (this.timer - Math.round((now - openedAt) / 1000) * 1000) / 1000;
    return html`
      <ix-dialog
        ?open=${this.open}
        prevent-cancel
        @closed=${this._handleClosed}
        @opened=${this._handleOpened}
      >
        <h1 slot="headline" class="dlr-text-heading">Log Out Warning</h1>

        <div slot="content" class="w-[380px] pb-[24px]">
          <div class="w-[270px]">
            <p class="text-[--ix-text-dark-second] leading-7">
              Due to inactivity, your session will <br />expire in
              ${this.timer / 60000} minutes.
            </p>
            <p
              class="dlr-text-heading my-3 text-[--clr-on-surface-critical] text-[1.5rem] mb-0 leading-[32px]"
            >
              ${`${Math.floor(timeInSeconds / 60)}:${String(timeInSeconds % 60).padStart(2, '0')}`}
            </p>
          </div>
        </div>
        <div slot="actions" class="p-[8px] pt-[8px] pl-[14px] justify-between">
          <ix-button
            @click=${() => {
              window.location.href = '/logout';
            }}
            appearance="text"
          >
            Log out now
          </ix-button>
          <ix-button @click=${() => (this.open = false)} appearance="text">
            Keep me signed in
          </ix-button>
        </div>
      </ix-dialog>
    `;
  }
}

window.customElements.define('ix-auto-logout-dialog', IxAutoLogoutDialog);
